import { branch, compose, lifecycle, withHandlers, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';

import {
  getAvailableTimesEndDay,
  getAvailableTimesStartDay,
} from '../utils/helpers';
import { clearBarberAvailability } from '../times/actions';
import WithFetchAvailability from './WithFetchAvailability';
import { ANY_BARBER } from '../constants';
import WithTimezone from './WithTimezone';

const BarberAvailableTimeRangeProvider = propStartDateKey =>
  compose(
    withPropsOnChange(['serviceDuration', 'barberId', 'shopId'], (props) => {
      props.clearBarberAvailability();
      props.fetchAvailability(props[propStartDateKey]);
    }),
  );

const ShopAvailableTimeRangeProvider = propStartDateKey =>
  compose(
    withPropsOnChange(['serviceId', 'shopId'], (props) => {
      props.clearBarberAvailability();
      props.fetchAvailability(props[propStartDateKey]);
    }),
  );

const AvailableTimeRangeProvider = propStartDateKey =>
  compose(
    WithFetchAvailability,
    WithTimezone,
    withHandlers({
      fetchAvailability: props => fromDate => props.fetchAvailability(
        getAvailableTimesStartDay(props.timezone)(fromDate),
        getAvailableTimesEndDay(props.timezone)(fromDate),
        props.appointmentId
      ),
    }),
    connect(null, { clearBarberAvailability }),
    branch(
      props => props.barberId === ANY_BARBER,
      ShopAvailableTimeRangeProvider(propStartDateKey),
      BarberAvailableTimeRangeProvider(propStartDateKey),
    ),
    lifecycle({
      componentDidMount() {
        this.props.fetchAvailability(this.props[propStartDateKey]);
      },
    }),
    withPropsOnChange([propStartDateKey], (props) => {
      props.fetchAvailability(props[propStartDateKey]);
    }),
  );

export default AvailableTimeRangeProvider;



// WEBPACK FOOTER //
// ./src/app/hoc/AvailableTimeRangeProvider.jsx